// Read by `index.html` before the first paint: an address that opens this company draws the shell's
// outline at once, in the icon's place, while the session and the shell's reads are on their way.
const KEY = "foreday:shell";

// Storage can be refused (a private window, blocked site data); the page then starts on the icon.
export function rememberShell(slug: string, icons: boolean): void {
  // Drawn once, for the page's first load: a later wait outside the shell shows the icon.
  delete document.documentElement.dataset.shell;
  try {
    localStorage.setItem(KEY, JSON.stringify({ slug, icons }));
  } catch {}
}

export function forgetShell(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}
